import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';

const firebaseApneConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_APNE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_APNE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_APNE_PROJECT_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APNE_APP_ID,
};

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

export let firebaseApneApp: FirebaseApp;
export let firebaseApp: FirebaseApp;

if (getApps().length === 0) {
  firebaseApneApp = initializeApp(firebaseApneConfig, 'apne');
  firebaseApp = initializeApp(firebaseConfig);
} else {
  firebaseApneApp = getApp('apne');
  firebaseApp = getApp();
}
